export const gridView = () => {
  return { type: "GRID" };
};

export const largeView = () => {
  return { type: "LARGE" };
};
